<!-- 用于商品批量关联图片 -->
<template>
    <div v-loading="loading" style="padding-bottom: 30px;">
        <div class="search-ctn-right">
            <div class="search-name">汽配编码</div>
            <!-- <el-input class="search-item" size="small" v-model.trim="apCode" v-filter-special-char="apCode" placeholder="请输入要获得图片的商品编码"></el-input> -->
            <el-autocomplete
                size="small"
                class="search-item"
                v-model="apCode"
                :fetch-suggestions="searchAPCode"
                :debounce="500"
                placeholder="请输入要获得图片的商品编码"
                :trigger-on-focus="false"
                v-scrollLoad="searchAPCodeLoad"
            ></el-autocomplete>
            <el-button size="small" class="search-btn btn-primary" @click="getSearchList">查询</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="allIn">全选</el-button>
            <el-button size="small" type="primary" class="search-btn" @click="submitData">共享图片</el-button>
        </div>
        <div style="color: red;margin-bottom: 20px;">
            选择需要同步的商品图片并关联。即可将另一个商品同步到该商品中。
        </div>
        <div class="img-list flex" v-if="searchList.length > 0">
            <div v-for="item in searchList" :key="item.Id">
                <img class="goods-imgs" :src="downloadUrl + item.ImgUrl + '?imageView2/2/w/200'" @click="opengoodImgVisible(downloadUrl + item.ImgUrl)"/>
                <el-checkbox class="goods-select" v-model="item.isRs" @change="selectImgs(item.Id,item.ImgUrl)"></el-checkbox>
                <div class="goods-main" v-if="item.isMain">主图</div>
            </div>
        </div>
        <div class="titile" v-else>
            <span>暂无商品数据</span>
        </div>
        <el-dialog
            :close-on-press-escape="false"
            title="查看大图"
            :visible.sync="goodImgVisible"
            width="1000px"
            append-to-body
            :before-close="closeGoodImgDialog"
        >
            <div v-if="goodImgVisible" class="flex-center">
                <el-image
                    class="big-imgs"
                    :src="showImgUrl"
                ></el-image>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['PictureList','GoodsId'],
    components: {},
    data() {
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            loading: false,
            page:1,
            limit: 20,
            apCode:'',
            goodImgVisible:false,
            showImgUrl:'',
            searchList:[],
            selectIds:[],///选中添加，搜索出其他数据后不影响已选中数据
            selectUrl:[],
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
        };
    },
    mounted() {
        // this.getSearchList();
    },
    methods: {
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            if (cb) {
                this.apCodeCallBack = cb;
            }
            if (this.apCodeForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (this.apCodeCallBack) {
                    this.apCodeCallBack(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        // 获取列表
        getSearchList() {
            let that = this;
            if(!this.apCode){
                this.$util.warningMsg("请输入汽配编码后再查询");
                return false;
            }
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsImageList',
                    data: {
                        GoodsId: that.GoodsId,
                        APCode: that.apCode,
                        page: that.page,
                        limit: that.limit,

                    },
                    hideLoading: true
                })
                .then(res => {
                    if(res.errcode == 0){
                        let data = [];
                        if(res.data.mainImgs.length > 0){
                            res.data.data = [...res.data.mainImgs,...res.data.data]
                        }

                        if(this.selectIds.length > 0){
                            data = res.data.data.map(x=>{
                                if(this.selectIds.indexOf(x.Id) > -1 || this.PictureList.indexOf(x.ImgUrl) > -1){
                                    x.isRs = true;
                                }
                                return x;
                            });
                        }else
                            data = res.data.data
                        
                        that.searchList = data;
                    }
                }).catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        selectImgs(value,url){
            let index = this.selectIds.indexOf(value);
            if(index > -1){
                this.selectIds.splice(index,1)
                this.selectUrl.splice(index,1)
            }else{
                this.selectIds.push(value)
                this.selectUrl.push(url)
            }
        },
        opengoodImgVisible(data){
            this.goodImgVisible = true;
            this.showImgUrl = data;
        },
        closeGoodImgDialog(){
            this.goodImgVisible = false;
            this.showImgUrl = '';
        },
        allIn(){
            var newArr = [];
            var isAll = this.searchList.filter(x=>x.isRs).length == this.searchList.length;

            this.searchList.forEach(x => {
                if(!x.isRs || isAll)
                    this.selectImgs(x.Id,x.ImgUrl);
                x.isRs = !isAll;
                newArr.push(x)
            });
            this.searchList = newArr;
        },
        submitData() {
            if(this.selectIds.length == 0){
                this.$util.warningMsg("请选择至少一张图片！");
                return false;
            }
            this.$util.successMsg("已关联选择的图片，请及时保存商品信息数据!");
            this.$emit('setImgRs',this.selectUrl);
        }
        // submitData() {
        //     this.loading = true;
        //     if(this.selectIds.length == 0){
        //         this.$util.warningMsg("请选着至少一张图片！");
        //         return false;
        //     }
        //     this.$util
        //         .axiosPost({
        //             url: '/api/EntpGoods/SubmitGoodsImageRs',
        //             data: { 
        //                 GoodsId: this.GoodsId,
        //                 ImgRsId : this.selectIds,
        //             },
        //             hideLoading: true
        //         })
        //         .then((res) => {
        //             this.$util.successMsg(res.errmsg);
        //             this.getSearchList();
        //         })
        //         .catch(() => {
        //         }).finally(() => {
        //             this.loading = false;
        //         });
        // },
    }
};
</script>
<style lang="less" scoped>
.search-ctn-right{
    margin-top: 10px;
    display: flex;
}

.search-item{
    width: 300px;
}
.search-btn{
    margin-left: 10px;
    height: 30px;
    min-width: 60px;
}
.img-list{
    height: 400px;
    width: 100%;
    flex-wrap:wrap;
    overflow:auto;
}
.titile{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    height: 400px;
}
.goods-imgs{
    width: 170px;
    height: 120px;
    margin:15px 0 0 35px;
}
.goods-select{
    position: relative;
    top: -42px;
    right: 20px;
}
.goods-main{
    position: relative;
    background-color: rgb(64,158,255);
    color: #fff;
    border-radius: 2px;
    text-align: center;
    width: 40px;
    height: 20px;
    font-size: 14px;
    bottom: 20px;
    left: 35px;
}
/deep/ .el-checkbox__inner{
    height: 20px;
    width: 20px;
}
/deep/ .el-checkbox__inner::after {
	left: 7px;
	top: 4px;
}
.flex-center{
    max-height: 660px;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.big-imgs{
    max-width: 1000px;
    max-height: 660px;
}
/deep/ .el-image__inner{
    max-height: 660px;
}
</style>
